export default __webpack_public_path__ + "static/media/i_bus-low-ggblue.879d527d.svg";